import { Context, CustomQuery } from '@vue-storefront/core';
export default async function getXml({ client, config }: Context, parms: CustomQuery): Promise<any> {
  const { xml } = parms;

  // console.log('[0]-------api开始登录--------', username, password);
  const url = new URL('/mall' + xml, config.api.url);
  const { data: res } = await client.get(url.href);
  return res;
}
